<div class="px-4 pb-5">
    <section class="h3 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
        <strong class="mb-2">{{title()}}</strong>
    </section>
    <p class="text-muted mb-4">
        Secure your spot on our farm-to-fridge list
    </p>

    <form [formGroup]="explorerPaymentMethodService.paymentForm" class="row g-4" novalidate>
        <div class="col-lg-12">
            <div class="row g-3">
                <div class="col-lg-6 col-md-12" [ngClass]="{'pe-5': !isMobile()}">
                    <div class="row g-3">
                        <!-- Card Information Section -->
                        <div class="col-12">
                            <h4 class="mb-3">Card Information</h4>
                        </div>

                        <div class="col-12">
                            <label class="form-label small fw-medium">CARD NUMBER*</label>
                            <div class="position-relative">
                                <input type="text" class="form-control pe-5" formControlName="cardNumber"
                                    (input)="onCardNumberInput($event)" [class.is-invalid]="invalid('cardNumber')"
                                    placeholder="0000 0000 0000 0000">
                                <img *ngIf="cardBrandIcon() as icon" [src]="icon" alt="brand" width="28" height="18"
                                    class="position-absolute top-50 end-0 translate-middle-y me-3" />
                            </div>
                            <div class="text-danger small" *ngIf="invalid('cardNumber')">Card number is required.</div>
                        </div>

                        <div class="col-6">
                            <label class="form-label small fw-medium">EXPIRATION DATE*</label>
                            <input type="text" class="form-control" formControlName="exp" placeholder="MM/YYYY"
                                inputmode="numeric" autocomplete="cc-exp" maxlength="7" (keydown)="onExpKeyDown($event)"
                                (input)="onExpInput($event)" (paste)="onExpPaste($event)"
                                [class.is-invalid]="invalid('exp')">
                            <ng-container *ngIf="invalid('exp')">
                                <div class="text-danger small"
                                    *ngIf="explorerPaymentMethodService.paymentForm.get('exp')?.errors?.['pattern']; else expReq">
                                    Expiration date must be in MM/YYYY format.
                                </div>
                                <ng-template #expReq>
                                    <div class="text-danger small">Expiration date is required.</div>
                                </ng-template>
                            </ng-container>
                        </div>

                         <div class="col-6">
                             <label class="form-label small fw-medium">SECURITY CODE*</label>
                             <div class="position-relative">
                                 <input type="text" class="form-control pe-5" formControlName="cvc" placeholder="CVC"
                                     [class.is-invalid]="invalid('cvc')" appOnlyNumber maxlength="4">
                                 <i class="fas fa-info-circle position-absolute top-50 end-0 translate-middle-y me-5 text-muted"></i>
                                 <i class="fas fa-credit-card position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                             </div>
                             <div class="text-danger small" *ngIf="invalid('cvc')">Security code is required.</div>
                         </div>

                        <div class="col-12 mt-4">
                            <div class="alert alert-secondary py-2 small mb-0">
                                <i class="fas fa-info-circle me-2"></i>
                                We will not charge your credit card until your selected shipping date
                                [{{deliveryDayText()}}] *
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-12" [ngClass]="{'ps-5 border-start': !isMobile()}">
                    <div class="row g-3">
                        <!-- Billing Address Section -->
                        <div class="col-12">
                            <h4 class="mb-3">Billing Address</h4>
                        </div>

                        <div class="col-12">
                            <label class="form-label small fw-medium">FIRST AND LAST NAME*</label>
                            <input type="text" class="form-control" formControlName="billingName" placeholder="First and Last Name"
                                [class.is-invalid]="invalid('billingName')">
                            <div class="text-danger small" *ngIf="invalid('billingName')">Name is required.</div>
                        </div>

                        <div class="col-12">
                            <label class="form-label small fw-medium">HOME ADDRESS*</label>
                            <input type="text" class="form-control" formControlName="billingAddress1" placeholder="Home Address"
                                [class.is-invalid]="invalid('billingAddress1')">
                            <div class="text-danger small" *ngIf="invalid('billingAddress1')">Address is required.</div>
                        </div>

                        <div class="col-12">
                            <label class="form-label small fw-medium">CITY*</label>
                            <input type="text" class="form-control" formControlName="billingCity" placeholder="City"
                                [class.is-invalid]="invalid('billingCity')">
                            <div class="text-danger small" *ngIf="invalid('billingCity')">City is required.</div>
                        </div>

                        <div class="col-6">
                            <label class="form-label small fw-medium">STATE*</label>
                            <select class="form-select" formControlName="billingState"
                                [class.is-invalid]="invalid('billingState')">
                                <option value="" disabled>State</option>
                                <option *ngFor="let st of states()" [value]="st.id">{{ st.name }}</option>
                            </select>
                            <div class="text-danger small" *ngIf="invalid('billingState')">State is required.</div>
                        </div>

                        <div class="col-6">
                            <label class="form-label small fw-medium">ZIP CODE*</label>
                            <input type="text" class="form-control" formControlName="billingZip" placeholder="ZIP Code"
                                [class.is-invalid]="invalid('billingZip')" appOnlyNumber maxlength="5">
                            <div class="text-danger small" *ngIf="invalid('billingZip')">ZIP code is required.</div>
                        </div>

                        <div class="col-12">
                            <hr>
                        </div>

                        <div class="col-12 mt-2">
                            <mat-checkbox formControlName="terms" color="primary" id="termsCheck" placeholder="Terms and Conditions">
                                <span class="fw-medium">
                                    * I AGREE TO THE 
                                    <a [routerLink]="['/terms-and-conditions']"
                                    target="_blank" rel="noopener noreferrer">TERMS & CONDITIONS</a>
                                </span>
                            </mat-checkbox>
                            <div class="text-danger small" *ngIf="invalid('terms')">Required</div>
                        </div>

                        <!-- Botón para procesar el pago -->
                        <div class="col-12 mt-4">
                            <button type="button" class="btn btn-secondary btn-lg w-max-content"
                                [disabled]="!explorerPaymentMethodService.paymentForm.valid" (click)="sendDataToANet()">
                                Submit
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>